import { Brick, registerBrick, Auth, CloudObject, User, WorkflowObjectState } from 'olympe';
import BCP from "../../common/section_bcp/DM_BCP";
import { getApplicationContext } from '../../common/utils/Context';
import {
  getCurrentWorkflow, getDisplayNames, getLoggedInUserDisplayName,
  BCP_WORKFLOW_STATES
} from './BcpWorkflowAuthorizations.js'
import { editInputEstimatefield} from '../../common/utils/CommonUtil'

export default class CheckStatusOfBCPForApproval extends Brick {

  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {*} bcp
   * @param {boolean} isAdmin
   * @param {*} context
   * @param {function()} forwardEvent
   * @param {function(boolean)} setCanAcceptOrNot
   */
  async update($, [bcp], [forwardEvent, setCanAcceptOrNot]) {
    // Write your code here.
    let loggedInUserEmail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp)
    let applicationContext = getApplicationContext($)
    const isAdmin = applicationContext.get('isadmin');
    const mailRegex = new RegExp(`.*${loggedInUserEmail}`, 'i');
    const loggedinUserDisplayName = getLoggedInUserDisplayName($)
    // Extract key roles and properties from bcp
    const roles = {
      businessPartner: bcp.get(BCP.businessPartnerProp),
      procurementManager: bcp.get(BCP.procurementManagerProp),
      ctagPerson: bcp.get(BCP.technicalApplicationGroupProp),
      sqaPerson: bcp.get(BCP.qualityAssuranceProp),
      qaFactoryPerson: bcp.get(BCP.qaInFactoryProp),
    };


    // Get the props values for column added for input saving,anycost and ghd reduction
    const alternativeVSCode = bcp.get(BCP.alternativeVendorCodeProp);
    const anyCostSaving = bcp.get(BCP.costSavingsProp)
    const ghdReduction = bcp.get(BCP.ghgReductionProp)
    const inputEstimateEdit = bcp.get(BCP.inputSavingEstimatesProp)
    const mainVendorLinkedAltVendor = bcp.get(BCP.mainVendorLinkedAltVendorProp)
    // for new vendor site- start
    // Now we have to validate if there is a new vendor to be added
    const vendorName = bcp.get(BCP.vdetNameProp)
    const vendorAddress = bcp.get(BCP.vdetAddressProp)
    const vendorCountry = bcp.get(BCP.vdetCountryProp)
    const vendorCity = bcp.get(BCP.vdetCityProp)
    const vendorContactNumber = bcp.get(BCP.vdetContactNumberProp)
    const vendorEmail = bcp.get(BCP.vdetEmailProp)
    // for new vendor site-end

    // Get current state of the workflow
    const currentState = getCurrentWorkflow(bcp, $)?.get(WorkflowObjectState.stateProp);
    const displayNames = getDisplayNames(bcp);
    //validate code -check the condition for PM  state manadatory value
    const pmFieldsValidateState = editInputEstimatefield(alternativeVSCode, mainVendorLinkedAltVendor,
      anyCostSaving, ghdReduction, inputEstimateEdit, vendorName, vendorAddress, vendorCountry,
      vendorCity, vendorContactNumber, vendorEmail)

    // Handle states with a switch statement
    switch (currentState) {
      case BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM:
        setCanAcceptOrNot(
          (mailRegex.test(roles.procurementManager?.toLowerCase()) ||
            loggedinUserDisplayName.toLowerCase() === displayNames.procurementManagerName?.toLowerCase() ||
            isAdmin) && roles.sqaPerson?.length > 0 &&
          Boolean(pmFieldsValidateState));
        break;
      default:
        setCanAcceptOrNot(false);
        break;
    }
    forwardEvent();
  }
}

registerBrick('0198756b815715cade95', CheckStatusOfBCPForApproval);
